import { v4 as uuidv4 } from 'uuid';
import { getCancellationServiceApiUrl } from '../selectors/selectors';
import { APPLICATION_JSON, CLIENT_ID, HOTEL } from '../constants/constants';

const iff = (condition, then, otherwise) => (condition ? then : otherwise);

export default {
  fetch: ({
    type,
    locale,
    channel,
    body,
    envConfig,
    correlationId,
  }, action, state) => ({
    url: `${getCancellationServiceApiUrl(state)}/${type?.toLowerCase()}/submit`,
    opts: {
      method: 'POST',
      credentials: 'include',
      timeout: iff(type?.toLowerCase() === HOTEL, 100e3, iff(type?.toLowerCase() === 'car', 80e3, 30e3)),
      headers: {
        Accept: APPLICATION_JSON,
        'Content-Type': APPLICATION_JSON,
        'x-client-id': CLIENT_ID,
        'x-correlation-id': correlationId || uuidv4(),
        'x-locale': locale,
        'x-user-agent': window.navigator.userAgent,
        'x-channel': channel,
        'x-timestamp': new Date().toISOString(),
        'x-tulips-env': envConfig?.['x-tulips-env'],
        ...envConfig?.['x-expediarapid-env'] && type?.toLowerCase() === HOTEL && {
          'x-expediarapid-env': envConfig?.['x-expediarapid-env'],
        },
      },
      body,
    },
  }),
};
